import { render, staticRenderFns } from "./estates.vue?vue&type=template&id=7ff8594c&"
import script from "./estates.vue?vue&type=script&lang=js&"
export * from "./estates.vue?vue&type=script&lang=js&"
import style0 from "./estates.vue?vue&type=style&index=0&id=7ff8594c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports